import { AutoMap } from "@automapper/classes";

export class ELIMSSample {

    @AutoMap()
    SampleCode: string = '';
    @AutoMap()
    ClientSampleCode: string = '';
    @AutoMap()
    Matrix: string = '';
    @AutoMap()
    ReceptionDate: Date = new Date();
    @AutoMap()
    EolReference: string = '';
    @AutoMap()
    Project: string = '';
    @AutoMap()
    BatchCode: string = '';
    @AutoMap()
    IsBlocked: boolean = false;

    // UI ONLY
    IsVisible: boolean = false;
    //

}